<script>
    export let value = false
    export let label = null
    export let disabled = false
    export let checked = false
    export let style = ''
    export let valid = true
    export let name = null
    import { onMount, onDestroy } from 'svelte'
    import Typography from './Typography.svelte'
    import { draw } from 'svelte/transition'
    import { getContext } from 'svelte'
    let formData = getContext('formData')
    $: checked = value
    function updateState() {
        if (name && formData)
            formData.update((x) => {
                return Object.assign(
                    x,
                    Object.fromEntries([
                        [
                            name,
                            {
                                valid: !!valid,
                                validation: false,
                                required: false,
                                value,
                                label,
                            },
                        ],
                    ])
                )
            })
    }
    onMount((_) => {
        updateState()
    })
    onDestroy((_) => {
        if (name && formData) {
            formData.update((all) => {
                return Object.fromEntries(
                    Object.entries(all).filter(([n]) => name != n)
                )
            })
        }
    })
    function keypress(event) {
        if (!disabled) value = !value
        if (['Enter', 'Space'].indexOf(event.code) !== -1) updateState()
    }
</script>

<div
    on:keypress={keypress}
    tabindex="0"
    {style}
    class:disabled
    on:click={(_) => {
        if (!disabled) value = !value
        updateState()
    }}
>
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <rect
            x="0.5"
            y="0.5"
            width="23"
            height="23"
            rx="3.5"
            fill="white"
            fill-opacity={disabled ? '0.3' : '1'}
            stroke={valid ? (disabled ? '#20252B' : '#B0B2B3') : '#E9573D'}
            stroke-opacity={disabled ? '0.3' : '1'}
        ></rect>
        {#if value}
            <g>
                <path
                    transition:draw={{ duration: 200 }}
                    d="M6.751,12.036L10.254,15.526L17.302,8.518"
                    stroke-opacity={disabled ? '0.3' : '1'}
                    style="fill:none;stroke:rgb(126,211,33);stroke-width:2.09px;stroke-miterlimit:1.5;"
                ></path>
            </g>
        {/if}
    </svg>
    {#if label}
        <Typography color={disabled ? 'grey-800' : 'black'} type="caption"
            >{label}</Typography
        >
    {:else}
        <Typography color={disabled ? 'grey-800' : 'black'} type="caption"
            ><slot /></Typography
        >
    {/if}
</div>

<style>
    div {
        display: flex;
        position: relative;
        flex-direction: row;
        /* justify-content: space-between; */
        align-items: center;
        gap: 12px;
        width: auto;
        color: black;
        cursor: pointer;
        user-select: none;
    }

    .disabled {
        cursor: no-drop;
    }
</style>
